exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#title .title[data-v-daa373f4]{width:100%;height:90px;background-color:#548df8;color:#fff}#title .title h1[data-v-daa373f4]{text-align:center;font:700 25px Lato,sans-serif;padding:13px 0 10px}#title .title .menu ul[data-v-daa373f4]{display:flex;flex-direction:row;justify-content:space-around;align-items:center;gap:0}#title .title .menu ul li:hover p[data-v-daa373f4]{color:#fff347}#title .title .menu ul li p[data-v-daa373f4]{padding:10px;color:#fff;font:500 13px/13px Roboto,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-daa373f4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/component/Header.vue
// module id = 40
// module chunks = 0